/* src/app/modules/shared/components/column/column-variant-type/column-variant-type.component.scss */
app-column-variant-type {
  display: contents;
}
/*# sourceMappingURL=column-variant-type.component.css.map */
